import React from "react";
import { useSelector } from "react-redux";
import DayClock from "../../../../shared/components/ui/DayClock/DayClock";
import iconsList from "../../../../shared/components/ui/icons/iconsList";

const FinalProjectTimer = ({ isSubmitted, presentationDate, submissionBox, isPopup }) => {
    const { texts } = useSelector(state => state.translate);
    const showDate = !isPopup;

    if (isSubmitted) {
        if (!presentationDate) return null;
        return (
            <DayClock
                label={texts.daysToPresentation}
                date={presentationDate}
                icon={iconsList.presentationIcon}
                color="#BC468E"
                showDate={showDate}
            />
        );
    }
    if (submissionBox?.isOpen) {
        if (submissionBox.isClosed) return null;
        return (
            <DayClock
                label={texts.daysToFinalProject}
                date={submissionBox.deadline}
                icon={iconsList.timerIcon}
                color="#00768F"
                showDate={showDate}
            />
        );
    }
    if (!submissionBox?.startDate) return null;
    return (
        <DayClock
            label={texts.daysToFinalProjectSubmission}
            date={submissionBox.startDate}
            icon={iconsList.timerIcon}
            color="#4E49C7"
            showDate={showDate}
        />
    );
};

export default FinalProjectTimer;
